/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'

export class AddMultipleSubjectWithAIDto { type = 1; companyName = ""; companyDefination = ""; subjectList: object[] = []; }

type Props = {}
const animatedComponents = makeAnimated();
const AddMultipleSubjectWithAIModal: FC<Props> = ({ }) => {
  const [isSubjectSuggestionsGetted, setIsSubjectSuggestionsGetted] = React.useState(false);
  const [isSubjectSuggestionsProgress, setisSubjectSuggestionsProgress] = React.useState(false);

  const createChannelSchema = Yup.object().shape({
    companyName: Yup.string()
      .min(3, LanguageHelp('Minimum 3 symbols'))
      .max(50, LanguageHelp('Maximum 50 symbols'))
      .required(LanguageHelp('Company name is required')),
    companyDefination: Yup.string()
      .min(50, LanguageHelp('Minimum 50 symbols'))
      .max(250, LanguageHelp('Maximum 250 symbols'))
      .required(LanguageHelp('Business defination is required')),
    type: Yup.string(),
    subjectList: Yup.array().when('type',
      (type, schema) => {
        if (isSubjectSuggestionsGetted) {
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
          }))
        } else {
          return schema;
        }
      }),
  })
  const [addMultipleSubjectWithAIDto, setAddMultipleSubjectWithAIDto] = useState(new AddMultipleSubjectWithAIDto())
  const { mode } = useThemeMode()

  const formik = useFormik({
    initialValues: addMultipleSubjectWithAIDto,
    // initialTouched:{ 
    //   companyName: true,
    //   companyDefination: true,
    // },
    validationSchema: createChannelSchema,
    // validateOnMount: true,
    onSubmit: async (values, { setSubmitting }) => {
      isSuccess = false
      try {
        var isSuccess = await addMultipleSubjectWithAIModal(values.subjectList)
        console.log(isSuccess, "isSuccess")
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
          setIsSubjectSuggestionsGetted(false);
        }
      }
    },
  })

  const getSubjectSuggestionsWithAI = async () => {

    if (!formik.touched.companyName || !formik.touched.companyDefination || formik.errors.companyName || formik.errors.companyDefination) {
      toast.error("LanguageHelp(response.data.message)");
      return false;
    } else {
      setisSubjectSuggestionsProgress(true);
      const toastId = toast.loading(LanguageHelp('Your process has been started!'));

      var payload = {
        companyName: formik.getFieldProps('companyName').value,
        businessDefination: formik.getFieldProps('companyDefination').value,
      }

      return axios
        .post(`${process.env.REACT_APP_API_URL}/reviewsubjects/GetSubjectSuggestionsWithAI`, payload)
        .then((response) => {
          if (response.data.httpStatusCode === 200) {

            if (response.data.message !== null) {
              toast.update(toastId, { render: LanguageHelp(response.data.message), type: "warning", isLoading: false, autoClose: 3000 });
            } else {
              var subjectSuggestions = response.data.result.data
              var subjectSuggestionsForInput: object[] = [];
              subjectSuggestions.forEach((subjectSuggestion: any) => {
                subjectSuggestionsForInput.push({ label: subjectSuggestion, value: subjectSuggestion })
              });

              setAddMultipleSubjectWithAIDto({
                ...addMultipleSubjectWithAIDto,
                subjectList: subjectSuggestionsForInput,
              })
              formik.setFieldValue('subjectList', subjectSuggestionsForInput)
              if (subjectSuggestionsForInput.length > 0) {
                setIsSubjectSuggestionsGetted(true);
              }

              toast.update(toastId, { render: LanguageHelp('Subject suggestions received successfully!'), type: "success", isLoading: false, autoClose: 3000 });
            }
          } else {
            toast.update(toastId, { render: response.data.message, type: "error", isLoading: false, autoClose: 3000 });
          }
          setisSubjectSuggestionsProgress(false);
          return response.data.result;
        })
        .then((response: any) => response)
    }
  }

  const addMultipleSubjectWithAIModal = async (subjectListForInput: object[]) => {
    var subjectList: string[] = []
    subjectListForInput.forEach(subjectOption => {
      subjectList.push(Object(subjectOption)['label'])
    });

    var payload = {
      subjectList: subjectList,
    }

    return axios
      .post(`${process.env.REACT_APP_API_URL}/reviewsubjects/AddMultipleReviewSubject`, payload)
      .then((response) => {
        if (response.data.httpStatusCode === 200) {

          if (response.data.message !== null) {
            toast.warning(LanguageHelp(response.data.message));
          } else {
            toast.success(response.data.result);
          }
        } else {
          toast.error(response.data.message);
        }
        return response.data.result;
      })
      .then((response: any) => response != null)
  }

  return (
    <div className='modal fade' id='kt_modal_AddMultipleSubjectWithAI' aria-hidden='true'>
      {/* <div className='modal-dialog modal-xl'> */}
      <div className='modal-dialog modal-dialog-centered mw-750px'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Add Multiple Subject With AI')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >

                {/* begin::Input group */}
                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Company Name')}</label>
                    <div className='col-lg-8 fv-row'>
                      <input
                        placeholder={LanguageHelp('Company Name')}
                        {...formik.getFieldProps('companyName')}
                        type='text'
                        name='companyName'
                        className={clsx('form-control form-control-lg form-control-solid')}
                        autoComplete='off'
                        disabled={formik.isSubmitting}
                      />
                      {formik.touched.companyName && formik.errors.companyName && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.companyName}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* end::Input group */}

                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Business Defination')}</label>
                    <div className='col-lg-8 fv-row'>
                      <textarea
                        placeholder={LanguageHelp('Business Defination')}
                        {...formik.getFieldProps('companyDefination')}
                        rows={3}
                        name='companyDefination'
                        className={clsx(
                          'form-control form-control-solid mb-3 mb-lg-0'
                        )}
                        autoComplete='off'
                        disabled={formik.isSubmitting}
                      />
                      {formik.touched.companyDefination && formik.errors.companyDefination && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.companyDefination}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {(isSubjectSuggestionsGetted == true) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                      <div className='col-lg-8 fv-row'>
                        <CreatableSelect
                          defaultValue={[]}
                          isMulti
                          className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          components={animatedComponents}
                          noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                          placeholder={LanguageHelp('Write one/several text(s)...')}
                          formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                          {...formik.getFieldProps('subjectList')}
                          onChange={(subjectList) => formik.setFieldValue('subjectList', subjectList)}
                          styles={{
                            control: (base) => ({ ...base, fontWeight: '600' })
                            , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                          }}
                        />
                        {formik.errors.subjectList !== undefined && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }


              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>

                <button
                  type='button'
                  onClick={() => getSubjectSuggestionsWithAI()}
                  className='btn btn-info me-3 mb-2'
                  data-kt-multisubject-modal-action='getSubjectSuggestionsWithAI'
                  disabled={!formik.isValid || !formik.touched}
                >
                  {(isSubjectSuggestionsProgress) && (
                    <span>
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span> {' '}
                    </span>
                  )}
                  {(!isSubjectSuggestionsProgress) && (
                    <i className="fas fa-wand-magic-sparkles"></i>
                  )}
                  {LanguageHelp('Get AI Suggestions')}
                </button>
                <button
                  type='submit'
                  className='btn btn-primary mb-2'
                  data-kt-multisubject-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <i className="fas fa-paper-plane"></i>
                  <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { AddMultipleSubjectWithAIModal }
